import { render } from "./CrudHospitals.vue?vue&type=template&id=037d48a8&scoped=true"
import script from "./CrudHospitals.vue?vue&type=script&lang=js"
export * from "./CrudHospitals.vue?vue&type=script&lang=js"

import "./CrudHospitals.vue?vue&type=style&index=0&id=037d48a8&lang=postcss"
import "./CrudHospitals.vue?vue&type=style&index=1&id=037d48a8&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037d48a8"]])

export default __exports__